import * as React from "react";
import { List, Datagrid, TextField, NumberField, FunctionField } from "react-admin";
import { FrDateField } from "../../components/FrDateField";
import { PersonChip } from "../../components/ui";
import { Chip } from "@mui/material";

const URA_TYPES = { ECHO_RESPONSE: "Réponse Échos", ECHO_POST: "Publication Échos", QUIZ: "Quiz", REFERRAL: "Parrainage", SESSION: "Séance", BOOKING: "Rendez-vous", FEEDBACK: "Avis", SPENT: "Dépense" };

// Ledger des points Ura (GET /admin/ura-transactions).
export default {
  list: () => (
    <List sort={{ field: "createdAt", order: "DESC" }} perPage={50} title="Transactions Ura">
      <Datagrid rowClick={false} bulkActionButtons={false}>
        <FunctionField label="Utilisateur" render={(r) => (
          // `user` = nom affiché, `userId` = identifiant (lien vers la fiche).
          <PersonChip id={r?.userId} name={r?.user} resource="users" dense />
        )} />
        <FunctionField label="Type" render={(r) => <Chip size="small" variant="outlined" label={URA_TYPES[r?.type] || r?.type || "—"} />} />
        <NumberField locales="fr-FR" source="amount" label="Montant (Ura)" />
        <TextField source="description" label="Description" />
        <FrDateField source="createdAt" label="Date" showTime />
      </Datagrid>
    </List>
  ),
};
